







import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";

import Checkbox from "@/shared/components/ui/Checkbox.vue";
import { useAccountAlertStore } from "@/shared/store/accountAlert";

@Component({
  components: {
    Checkbox
  }
})
export default class AccountAlertBellCobrand extends Vue {

  accountAlertStore = useAccountAlertStore();

  @Prop()
  whiteIcon: boolean;

  handleClick () {
    this.accountAlertStore.togglePanelOpen();
  }

}
